import { Button } from "antd";
import React, { useCallback } from "react";
import { GlobalBtnStatusDesc, GlobalBtnStatusText, GlobalStatus } from "../../type";
import "./index.less";
interface IProps {
  status: GlobalStatus;
  currentSuccessTaskCount: number;
  totalTaskCount: number;
  handleCancelAll: () => void;
  handleRetryAll: () => void;
}

const Header = (props: IProps) => {
  const {
    status,
    currentSuccessTaskCount,
    totalTaskCount,
    handleCancelAll,
    handleRetryAll
  } = props;
  // console.log(status, 'statusstatusstatusstatusstatus');
  return (
    <div className="download-header">
      <span className="desc">
        {GlobalBtnStatusDesc.PROGRESS_ALL}
        {currentSuccessTaskCount}/{totalTaskCount}个文件
      </span>
      <span className="downloadall-btn">
        {status === GlobalStatus.PROGRESS_ALL && (
          <Button
            type="link"
            block
            onClick={() => {
              handleCancelAll();
            }}
          >
            {GlobalBtnStatusText.CANCEL_ALL}
          </Button>
        )}
        {(status === GlobalStatus.CANCEL_ALL ||
          status === GlobalStatus.MOIETY_ERROR ||
          status === GlobalStatus.ERROR_ALL) && (
          <Button
            type="link"
            block
            onClick={() => {
              handleRetryAll();
            }}
          >
            {GlobalBtnStatusText.RETRY_ALL}
          </Button>
        )}
      </span>
    </div>
  );
};

export default Header;
